// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Ri3Fp","productName":"Table_productName__3gG5Z"};